export default{
    setLoad(state,payload){
        state.load=payload.value;
    }
}